import React, { useState, useEffect } from "react";
import { CiSearch } from "react-icons/ci";
import { TbArrowBackUp } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { API_HOST } from "../../api_utils";
import { clearCustomerHeadData } from "../../Redux/Action/CustomerHeadActions";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineKeyboardBackspace } from "react-icons/md";

function CustomerDetailIdCheck(props) {
  let navigate = useNavigate();
  let dispatch = useDispatch();

  const [customerId, setCustomerId] = useState("");
  const [customerId1, setCustomerId1] = useState("");
  const [customerId2, setCustomerId2] = useState("");
  const [loading, setLoading] = useState(false);

  const goBackToCustomerHandler = () => {
    navigate("/customers/overview");
  };

  const { userDataFromStorage, coloredTheme } = props;

  useEffect(() => {
    dispatch(clearCustomerHeadData());
  }, []);

  const CustomerDetailHeaderHandler = async () => {
    if (
      customerId.length > 0 ||
      customerId1.length > 0 ||
      customerId2.length > 0
    ) {
      console.log("customerId", customerId);
      console.log("customerId1", customerId1);
      console.log("customerId2", customerId2);
      const customIdFix = `${customerId}-${customerId1}-${customerId2}`;
      console.log("customFix:::", customIdFix);
      console.log("inside message222:::::::", customIdFix);
      navigate(`/customers/header/${customIdFix}`);
    } else {
      toast.warning("Please Provide A Customer ID");
    }
  };

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden min-h-[80vh]"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <div className="flex justify-start items-center space-x-4">
        <p
          onClick={() => navigate("/customers/overview")}
          className="text-[2.3rem] text-gray-700 hover:text-gray-300 transition duration-[0.5s]">
          <MdOutlineKeyboardBackspace />
        </p>
        <p className="text-gray-800 text-[1.8rem] tracking-wider">
          Customer Detail
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-start items-center space-y-3 md:space-y-0 md:space-x-4 mt-4 ">
        <input
          value={customerId}
          onChange={(e) => setCustomerId(e.target.value)}
          type="text"
          id="idCheckCustomer1"
          className="border  rounded-lg p-[0.5rem] w-[100%]  outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e] md:w-[8rem]"
        />
        <input
          value={customerId1}
          onChange={(e) => setCustomerId1(e.target.value)}
          type="text"
          id="idCheckCustomer2"
          className="border md:w-[8rem] w-[100%]  rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
        />
        <input
          value={customerId2}
          onChange={(e) => setCustomerId2(e.target.value)}
          type="text"
          id="idCheckCustomer"
          className="border md:w-[8rem] w-[100%] rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
        />
        <button
          style={{ backgroundColor: coloredTheme }}
          onClick={CustomerDetailHeaderHandler}
          className="flex justify-center items-center space-x-2   text-green-50  hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded ">
          <CiSearch className="text-2xl " />
          <span>Check ID</span>
        </button>
      </div>
      <div className="md:mt-[3%] mt-[10rem]">
        <button
          style={{ backgroundColor: coloredTheme }}
          onClick={goBackToCustomerHandler}
          className="flex justify-center items-center space-x-2 text-orange-50 px-[1rem] py-[0.5rem] rounded   hover:shadow-2xl hover:shadow-black">
          <TbArrowBackUp className="text-2xl " />
          <span>Cancel</span>
        </button>
      </div>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default CustomerDetailIdCheck;
